import EventEmitter from 'events';
import SDIConstants from '../SDIConstants';
import { Dispatcher } from 'simplr-flux';
import * as $ from 'jquery';

class ExpressPutAwayStore extends EventEmitter {
    PageLoadData = "";
    SaveItemData = "";
    updateFavPageResponse = { updateType: 0, responseStr: "" };
    handleExpressPutAway = (action) => {
        switch (action.action.type) {
            case "PageLoad": {
                this.PageLoadData = action.action.response;
                this.emit('PageLoad');
                break;
            }
            case "SaveItem": {
                this.SaveItemData = action.action.response;
                ;
                this.emit('SaveItem');
                break;
            }
            //WW-38 Need to add Description and Unit Of Measure (UOM) fields to Express Put Away page. UOM should be shown in all Transaction pages - Deepthi
            case "SearchItem": {
                this.SearchItemData = action.action.response;
                ;
                this.emit('SearchItem');
                break;
            }
            case "NOTIFY_InsertFavPage": {

                this.updateFavPageResponse.updateType = 1;
                this.updateFavPageResponse.responseStr = action.action.response;
                this.emit('updateFavPage');
                break;
            }
            case "NOTIFY_DeleteFavPage": {
                this.updateFavPageResponse.updateType = 2;
                this.updateFavPageResponse.responseStr = action.action.response;
                this.emit('updateFavPage');
                break;
            }
            case "NOTIFY_CurrentFavPage": {
                this.currentFavPageResponse = action.action.response;
                this.emit('favpage');
                break;
            }
            case "workordercheck": {
                this.workorderresponse = action.action.response;
                this.emit('workordercheck');
                break;
            }
            case "workorderfail": {
                this.workorderresponse = "fail";
                this.emit('WOfail');
                break;

            }
        }
    }
}
const objExpressPutAwayStore = new ExpressPutAwayStore;
// Dispatcher code
Dispatcher.register(objExpressPutAwayStore.handleExpressPutAway.bind(objExpressPutAwayStore));
export default objExpressPutAwayStore;